module.exports = __webpack_public_path__ + "static/media/appOrGame.3c07a03c.svg";